import { getPaneMode } from "../taskpane";

export const useOutlook = () => {
  return {
    isInReadMode: getPaneMode() === "read",
    isInComposeMode: getPaneMode() === "compose",
  };
};
